import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, ShoppingCartIcon, BrainIcon, ShieldCheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: BookOpenIcon,
    title: 'Ebook Cero Inflamación en 72h',
    description: 'El manual paso a paso con el protocolo exacto.'
  }, {
    icon: CalendarIcon,
    title: 'Cronograma Diario',
    description: 'Qué comer desde que despiertas hasta que duermes (Día 1, 2 y 3).'
  }, {
    icon: ShoppingCartIcon,
    title: 'Lista de Compras de "La Plaza"',
    description: 'Ingredientes económicos y fáciles de conseguir en Colombia.'
  }, {
    icon: BrainIcon,
    title: 'Técnica de Masticación 20/20',
    description: 'El truco mental para silenciar el hambre por ansiedad.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Guía de Mantenimiento',
    description: 'Cómo evitar el efecto rebote y comer fuera sin miedo.'
  }];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-209">
      <div className="max-w-4xl mx-auto px-4" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-211">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          color: '#1A1A1A'
        }} data-id="element-212">
            ¿Qué incluye el protocolo?
          </h2>

          <p className="text-center text-lg mb-12" style={{
          color: '#4A4A4A'
        }} data-id="element-213">
            Todo lo que necesitas para desinflamarte en un solo paquete:
          </p>

          <div className="space-y-4" data-id="element-214">
            {items.map((item, index) => <motion.div key={index} className="flex items-start gap-4 p-5 md:p-6 bg-white rounded-2xl shadow-sm" style={{
            border: '1px solid #C5DDD1'
          }} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-215">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: '#C5DDD1'
            }} data-id="element-216">
                  <item.icon className="w-6 h-6" style={{
                color: '#1A1A1A'
              }} data-id="element-217" />
                </div>
                <div data-id="element-218">
                  <h3 className="text-lg md:text-xl font-semibold mb-1" style={{
                color: '#1A1A1A'
              }} data-id="element-219">
                    {item.title}
                  </h3>
                  <p className="text-base" style={{
                color: '#4A4A4A'
              }} data-id="element-220">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}